// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2Tn6g","icon":"SortAdornment_icon__2Ibhf","up":"SortAdornment_up__30hUY","down":"SortAdornment_down__1g6v9","active":"SortAdornment_active__Hj9eb"};